import { gql, useMutation } from "@apollo/client";

export const REMOVE_MACHINE = gql`
  mutation removeMachine($id: String!) {
    removeMachine(id: $id)
  }
`;